export default [
    {
        path: "bonus-extra-hours",
        name: "bonusExtraHours",
        component: () =>
            import(
                /* webpackChunkName: "AppErrorlogs" */ "../pages/bonusExtraHour/BonusExtraHours.vue"
            ),
        meta: {
            title: `Bonus Extra Hour`,
        },
    },
    
];
